import React, { CSSProperties, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import hp_logo from '../assets/hp_logo.png'
import page_not_found_icon from '../assets/page_not_found_icon.png'

import { isScreenSizeSmall } from './common/utils'

const PageNotFound: React.FC = () => {
  const { t } = useTranslation()
  const [isFooterVisible, setIsFooterVisible] = useState(false)
  const [isBackButtonHovered, setIsBackButtonHovered] = useState(false)

  const handleScroll = () => {
    const isScrollable =
      document.documentElement.scrollHeight > window.innerHeight
    const isBottom =
      window.innerHeight + window.scrollY >=
      document.documentElement.scrollHeight - 1
    setIsFooterVisible(!isScrollable || isBottom)
  }

  useEffect(() => {
    handleScroll()
    window.addEventListener('scroll', handleScroll)
    window.addEventListener('resize', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleScroll)
    }
  }, [])

  return (
    <>
      <div className="container responsive-font" style={centerContent}>
        <figure>
          <img
            alt="Page not found icon"
            style={
              isScreenSizeSmall()
                ? responsivePageNotFoundIcon
                : pageNotFoundIcon
            }
            src={page_not_found_icon}
          />
          <figcaption className="responsive-font mt-3">
            {t('404_not_found')}
          </figcaption>
        </figure>
        <div>
          <h3
            className={`responsive-header ${
              isScreenSizeSmall() ? 'mt-5' : 'mt-4'
            }`}
          >
            {t('page_not_found')}
          </h3>
          <p className="mt-3"> {t('url_does_not_exist')} </p>
          <button
            className="btn btn-outline-primary responsive-button text-nowrap mt-3"
            style={isBackButtonHovered ? backButtonHover : backButton}
            onClick={() => window.history.back()}
            onMouseEnter={() => setIsBackButtonHovered(true)}
            onMouseLeave={() => setIsBackButtonHovered(false)}
          >
            {t('back')}
          </button>
        </div>
      </div>
      {isFooterVisible && (
        <footer className="responsive-font" style={footer}>
          {t('kms_admin_portal')}
          <div
            style={isScreenSizeSmall() ? responsiveVerticalLine : verticalLine}
          ></div>
          <img
            src={hp_logo}
            alt="HP logo"
            style={isScreenSizeSmall() ? responsiveHPLogo : hpLogo}
          />
        </footer>
      )}
    </>
  )
}

export default PageNotFound

/* Styles for the unauthorized page icon */
const pageNotFoundIcon: CSSProperties = {
  marginTop: '5%',
  height: 'min(30vh, 30vw)',
  width: 'min(30vh, 30vw)',
}

/* Styles for the unauthorized page icon */
/* Applies styles when the viewport width is 991px or less */
const responsivePageNotFoundIcon: CSSProperties = {
  marginTop: '15%',
  height: 'min(35vh, 35vw)',
  width: 'min(40vh, 40vw)',
}

/* Center content alignment */
const centerContent: CSSProperties = {
  textAlign: 'center',
}

/* Styles for the back button */
const backButton: CSSProperties = {
  color: '#0096d6',
  borderColor: '#0096d6',
  paddingLeft: '10px',
  paddingRight: '10px',
  marginBottom: '80px',
}

const backButtonHover: CSSProperties = {
  backgroundColor: '#0096d6',
  borderColor: '#0096d6',
}

/* Styles for the footer */
const footer: CSSProperties = {
  position: 'fixed',
  bottom: '20px',
  right: '20px',
  verticalAlign: 'middle',
}

/* Styles for the vertical line in the footer */
const verticalLine: CSSProperties = {
  display: 'inline-block',
  width: '2px',
  height: 'min(3.5vh, 3.5vw)',
  backgroundColor: '#000',
  verticalAlign: 'middle',
  margin: '10px',
}

/* Styles for the vertical line in the footer */
/* Applies styles when the viewport width is 991px or less */
const responsiveVerticalLine: CSSProperties = {
  display: 'inline-block',
  width: '4px',
  height: 'min(6vh, 6vw)',
  backgroundColor: '#000',
  verticalAlign: 'middle',
  margin: '15px',
}

/* Styles for the HP logo in the footer */
const hpLogo: CSSProperties = {
  height: 'min(5vh, 5vw)',
  width: 'min(5vh, 5vw)',
}

/* Styles for the HP logo in the footer */
/* Applies styles when the viewport width is 991px or less */
const responsiveHPLogo: CSSProperties = {
  // marginLeft: '5px',
  height: 'min(8vh, 8vw)',
  width: 'min(8vh, 8vw)',
}
